<template>
  <div class="charge-edit">
    <div class="row">
      <div class="label">设备类型</div>
      <div class="row-right">
        电动车
      </div>
    </div>
    <div class="row">
      <div class="label">中控号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="udid"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">车牌号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="frameNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">车架号</div>
      <div class="row-right">
        <el-input class="fixed-width-200" type="text" v-model="vinNo"></el-input>
      </div>
    </div>
    <div class="row">
      <div class="label">设备状态</div>
      <div class="row-right">
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="putStatus">
          <el-option
            v-for="(item,key) in putStatusList"
            :key="item.id"
            :label="item.text"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="label">设备照片</div>
      <div class="row-right">
        <span class="img-box">
          <div>车牌照</div>
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :auto-upload="false"
            accept="image/*"
            :on-change="(file, fileList)=>handleUpload(file, fileList, 0)">
            <img v-if="pictureSrc" :src="pictureSrc" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </span>
        <span class="img-box">
          <div>车后视角照片</div>
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :auto-upload="false"
            accept="image/*"
            :on-change="(file, fileList)=>handleUpload(file, fileList, 1)">
            <img v-if="pictureSrc1" :src="pictureSrc1" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </span>
        <span class="img-box">
          <div>车侧视角照片</div>
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            :auto-upload="false"
            accept="image/*"
            :on-change="(file, fileList)=>handleUpload(file, fileList, 2)">
            <img v-if="pictureSrc2" :src="pictureSrc2" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="normal-btn" @click="cancel">取消</div>
      <div class="blue-btn" @click="confirm">确认</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'electricBicycleMgmtAddView',
  data() {
    return {
      udid: '',
      frameNo: '',
      vinNo: '',
      pictureSrc: '',
      pictureSrc1: '',
      pictureSrc2: '',
      putStatus: '',
      putStatusList: [
        {
          id: '1',
          text: '待投放'
        }, {
          id: '2',
          text: '已投放'
        },
      ],
      file: null
    };
  },
  mounted() {
  },
  methods: {
    confirm() {
      this.addOrEditDevice();
    },
    cancel() {
      this.$emit('cancel');
    },
    addOrEditDevice() {
      let self = this;
      if (!this.pictureSrc) {
        this.$message({
          type: "warning",
          message: '请上传车牌照！',
          center: true
        });
      }
      let pictureList = this.pictureSrc.split(',');
      let pictureList1 = this.pictureSrc1.split(',');
      let pictureList2 = this.pictureSrc2.split(',');
      let params = {
        udid: this.udid,
        frameNo: this.frameNo,
        vinNo: this.vinNo,
        status: this.putStatus,
        picture0: pictureList[1],
        type0: pictureList[0].split(';')[0].split('/')[1],
        picture1: pictureList1[1],
        type1: pictureList1[0].split(';')[0].split('/')[1],
        picture2: pictureList2[1],
        type2: pictureList2[0].split(';')[0].split('/')[1],
      }
      this.$http.post('/managementPlatform/electricity/addNewElectricBicycle', this.$qs.stringify(params)
      ).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message,
            center: true
          });
          return;
        }
        self.$message({
          type: "success",
          message: "添加成功!",
          center: true
        });
        self.$emit('addSuccess');
      }).catch(function (response) {
        console.log(response);
      });
    },
    handleUpload(file, fileList, type) {
      let self = this;
      let fileReader = new FileReader();
      if (type == 0) {
        fileReader.onloadend = function (e) {
          self.pictureSrc = e.target.result;
        }
        fileReader.readAsDataURL(file.raw);
      }
      if (type == 1) {
        fileReader.onloadend = function (e) {
          self.pictureSrc1 = e.target.result;
        }
        fileReader.readAsDataURL(file.raw);
      }
      if (type == 2) {
        fileReader.onloadend = function (e) {
          self.pictureSrc2 = e.target.result;
        }
        fileReader.readAsDataURL(file.raw);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 0 0 20px;
  font-size: 14px;

  .fixed-width {
    width: 240px;
  }

  .row-right {
    display: inline-block;
    line-height: 30px;

    .img-box {
      display: inline-block;
    }

    .top {
      vertical-align: top;
      color: #999999;
    }
  }

  .label {
    display: inline-block;
    vertical-align: top;
    text-align: left;
    min-width: 100px;
    margin-right: 14px;
    line-height: 25px;
  }

  .blue-btn {
    margin-right: 10px;
  }

  .table-custom {
    width: 920px;
  }

  .fixed-width-200 {
    width: 200px;
    vertical-align: top;
  }

  .fixed-width-350 {
    width: 350px;
    vertical-align: top;
  }

  .fixed-width-450 {
    width: 450px;
    vertical-align: top;
  }

  .btn {
    cursor: pointer;
  }

  .icon {
    color: #67aa42;
    font-size: 20px;
  }
}

.amap-demo {
  height: 300px;
  margin: 20px 0;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 150px;
  box-sizing: border-box;
  line-height: 150px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.avatar {
  width: 200px;
  height: 150px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/electricBicycleAddView.vue